const apiBaseUrl = import.meta.env.VITE_API_BASE_URL?.trim()

if (!apiBaseUrl) {
  console.warn(
    '[config] VITE_API_BASE_URL is not set. API calls will fail until configured.',
  )
}

export const env = {
  apiBaseUrl: apiBaseUrl || 'http://localhost:4000/api/v1',
  appEnv: import.meta.env.VITE_APP_ENV || 'development',
  isDev: import.meta.env.DEV,
}
